<template>
  <div class="2">
    <BaseTable
      class="actions-table"
      :items="displayItems"
      :fields="fields"
      hover
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      @sort-changed="onSortChanged"
    >
      <template #cell(actions)>
        <BaseDropdown right variant="light">
          <template #button-content>
            <i class="fa-solid fa-ellipsis"></i>
          </template>
          <li><button class="dropdown-item" type="button">Edit</button></li>
          <li><button class="dropdown-item" type="button">Delete</button></li>
        </BaseDropdown>
      </template>

      <template #cell(status)="slotProps">
        <span v-html="getStatusHtml(slotProps.data.value)"></span>
      </template>
    </BaseTable>

    <BaseModal v-model="showInfoModal" :title="infoModal.title" ok-only>
      <pre>{{ infoModal.content }}</pre>
    </BaseModal>
  </div>
</template>

<script>
import BaseDropdown from '../base/BaseDropdown.vue'
import BaseModal from '../base/BaseModal.vue'
import BaseTable from '../base/BaseTable.vue'

export default {
  components: {
    BaseDropdown,
    BaseModal,
    BaseTable
  },
  data () {
    return {
      items: [
        { code: 'E660', type: 'Online', status: false, email: 'test@test.se', name: { first: 'Mitzi', last: 'Navarro' } },
        { code: 'E660', type: 'Online', status: false, email: 'test@test.se', name: { first: 'Genevieve', last: 'Wilson' } },
        { code: 'E660', type: 'Online', status: true, email: 'test@test.se', name: { first: 'John', last: 'Carney' }, _cellVariants: { status: 'danger' } },
        { code: 'E660', type: 'Online', status: false, email: 'test@test.se', name: { first: 'Dick', last: 'Dunlap' } }
      ],
      fields: [
        { key: 'code', label: 'Code', sortable: true, sortDirection: 'desc' },
        { key: 'email', label: 'E-mail', sortable: true, class: 'email-column' },
        { key: 'type', label: 'Form Type', sortable: true },
        { key: 'status', label: 'Status', sortable: true, sortByFormatted: true, filterByFormatted: true },
        { key: 'actions', label: 'Actions', class: 'ellipsis-button' }
      ],
      totalRows: 1,
      sortBy: '',
      sortDesc: false,
      filter: null,
      showInfoModal: false,
      infoModal: {
        id: 'info-modal',
        title: '',
        content: ''
      }
    }
  },
  computed: {
    displayItems () {
      if (!this.filter) return this.items
      const term = this.filter.toString().toLowerCase()
      return this.items.filter(item => JSON.stringify(item).toLowerCase().includes(term))
    }
  },
  mounted () {
    this.totalRows = this.items.length
  },
  methods: {
    info (item, index) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.showInfoModal = true
    },
    resetInfoModal () {
      this.infoModal.title = ''
      this.infoModal.content = ''
      this.showInfoModal = false
    },
    getStatusHtml (value) {
      return !value ? 'Sent' : 'Not sent <a class="ml-1">Send invitation</a>'
    },
    onSortChanged ({ sortBy, sortDesc }) {
      this.sortBy = sortBy
      this.sortDesc = sortDesc
    }
  }
}
</script>

<style>
  .email-column {
    width: 100%;
  }
  .table thead th {
    white-space: nowrap;
  }
  .table tbody td {
    white-space: nowrap;
  }
  .table tbody td.email-column {
    width: auto;
  }
</style>
